import { render, staticRenderFns } from "./global-layout.vue?vue&type=template&id=919c5e76&"
import script from "./global-layout.vue?vue&type=script&lang=js&"
export * from "./global-layout.vue?vue&type=script&lang=js&"
import style0 from "./global-layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports